export default "__VITE_ASSET__CUusdonL__"